<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">메시지 발송</span>
            <span class="txt">회원에게 메시지를 발송/예약할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button class="on">SMS(문자메시지)</button>
            <button @click="onClickRouter('/madmin/message/send/alert')">알림톡</button>
            <button @click="onClickRouter('/madmin/message/send/auto')">SMS/알림톡 자동 발송</button>
        </div>

        <div class="msg-send-wrap">
            <div class="com-screen-box">
                <div class="phone-screen-wrap">
                    <div class="com-info-wrap">
                        <div class="tit">
                            <span>자동 치환 문자 안내</span>
                            <div class="com-tooltip">
                                <button class="icon"></button>
                                <div class="detail">
                                    <span class="tit">이용권 결제등록 완료시점에 자동발송 됩니다.</span>
                                    <p class="txt">
                                        <span class="red">[추가 사용 가능한 치환문자]</span>
                                        <br />
                                        #{담당강사} : 이용권의 지정된 담당강사
                                        <br />
                                        #{이용권명} : 이용권명
                                        <br />
                                        #{유효기간} : (예시 : 2020-01-01 ~ 2020-02-28)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="com-info-cont-list">
                            <dl>
                                <dt>
                                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{회원명}</span>
                                </dt>
                                <dd>회원 이름</dd>
                            </dl>
                            <dl>
                                <dt>
                                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터명}</span>
                                </dt>
                                <dd>센터명 ({{ centerInfo.centerName }})</dd>
                            </dl>
                            <dl>
                                <dt>
                                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">
                                        #{센터번호}
                                    </span>
                                </dt>
                                <dd>센터대표전화번호 ({{ centerInfo.telNo | phoneNumberFilter }})</dd>
                            </dl>
                            <span class="com-info-cont-txt">
                                * 50건 이상의 대량 발송 시 치환 문구는 위 3개만 지원됩니다.
                            </span>
                        </div>
                    </div>

                    <div class="line">
                        <span class="tit">
                            내용 입력
                            <span class="require">*</span>
                        </span>
                        <div class="input-cnt flex-col">
                            <div v-if="isAdvertEnabled">
                                <div class="readonly-text" style="margin-bottom: -38px">
                                    {{ fullAdvertText }}
                                </div>
                                <textarea
                                    class="com-textarea-ad"
                                    v-model="content"
                                    placeholder="메시지 내용을 입력하세요."
                                ></textarea>
                                <div class="readonly-text" style="margin-top: -40px">
                                    {{ advertText.suffix }}
                                </div>
                            </div>
                            <textarea
                                v-else
                                class="com-textarea"
                                v-model="content"
                                placeholder="메시지 내용을 입력하세요."
                            ></textarea>
                            <p class="input-info">
                                {{ num }}/ {{ totalNum }} byte
                                <span class="blue">{{ messageTypeDisplay }}</span>
                            </p>
                        </div>
                    </div>

                    <div class="line">
                        <div class="line-wrap">
                            <div class="tit">
                                <span>
                                    이미지 첨부
                                    <span class="text-black-50">(선택)</span>
                                </span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">
                                            확장자 jpg,jpeg / 사이즈 1280x720 권장, 최대 3장 첨부 가능
                                            <br />
                                            용량 최대 600kb 사진 1장당 200kb 이하 권장합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <span class="line-info text-black-50">
                                ※ 확장자 jpg,jpeg / 사이즈 1280x720 권장, 최대 3장 첨부 가능
                                <br />
                                용량 최대 600kb 사진 1장당 200kb 이하 권장
                            </span>
                        </div>
                        <div class="img-area">
                            <div class="image-upload-container">
                                <!-- 숨겨진 파일 입력 필드 -->
                                <b-form-file
                                    ref="fileInput"
                                    id="fileInput"
                                    accept="image/jpeg"
                                    @change="readUrl"
                                    v-model="imageFile"
                                    style="display: none"
                                    multiple
                                ></b-form-file>

                                <!-- 이미지 미리보기 및 삭제 버튼 영역 -->
                                <div v-for="(image, index) in images" :key="index" class="img-thumbnail">
                                    <img :src="image.url" alt="미리보기 이미지" class="preview-image" />
                                    <button type="button" @click="deleteImage(index)" class="delete-btn">
                                        <i class="ico-delete"></i>
                                    </button>
                                </div>

                                <!-- 이미지 추가 버튼 -->
                                <label for="fileInput" class="img-add" v-if="images.length < 3">
                                    <i class="ico-plus"></i>
                                    이미지 추가
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="msg-box">
                <!-- 발송 정보 -->
                <div class="com-table-wrap send-info">
                    <div class="top-title">
                        <span class="title">발송 정보</span>
                    </div>
                    <div class="cont-wrap">
                        <!-- 광고문자 설정 체크박스 -->
                        <div class="line">
                            <div class="line-wrap">
                                <div class="check">
                                    <span class="sub-head">광고문자 설정</span>
                                    <div class="com-design-check">
                                        <input id="check-sms-1-1" type="checkbox" v-model="isAdvertEnabled" />
                                        <label for="check-sms-1-1"></label>
                                    </div>
                                </div>
                                <button class="txt-blue txt-underline" @click="advertNotiPop = true">
                                    광고문자 발송 가이드
                                </button>
                            </div>
                        </div>

                        <!-- [광고] 센터명 입력 필드, 광고문자 설정 활성화 시에만 표시 -->
                        <div class="line" v-if="isAdvertEnabled">
                            <span class="sub-head">
                                [광고] 센터명
                                <span class="require">*</span>
                            </span>
                            <div class="input-cnt">
                                <input maxlength="30" type="text" class="w120" readonly value="(광고)" />
                                <select-form
                                    :select-data="centerNames"
                                    :select-value="selectedCenterName"
                                    @update:set="(val) => (selectedCenterName = val)"
                                    @update:selected="(val) => (selectedCenterName = val)"
                                ></select-form>
                                <input
                                    v-if="selectedCenterName === '직접 입력'"
                                    v-model="userInput"
                                    maxlength=""
                                    type="text"
                                    class="w100per mt-8"
                                />
                            </div>
                        </div>
                        <!-- [광고] 수신거부번호 입력 필드, 광고문자 설정 활성화 시에만 표시 -->
                        <div class="line" v-if="isAdvertEnabled">
                            <span class="sub-head">
                                [광고] 수신거부번호
                                <span class="require">*</span>
                            </span>
                            <div class="input-cnt">
                                <input maxlength="30" type="text" class="w120" value="무료수신거부" readonly />
                                <input maxlength="30" type="text" value="080-560-5608" readonly />
                            </div>
                        </div>

                        <div class="line">
                            <span class="sub-head">
                                발신번호
                                <span class="require">*</span>
                            </span>
                            <div class="input-cnt">
                                <!-- <select-form :select-data="['선택', ...sortSend]" :select-value="['', ...sortSendNo]"
                                    :selectedValue="sendNo defaultSendNo" @update:set="(val) => (sendNo = val)"
                                    @update:selected="(data) => (sendName = data)"></select-form> -->
                                <!-- <select-form :select-data="[...sortSend]" :select-value="[...sortSendNo]"
                                    :selectedValue="sendNo" @update:set="(val) => (sendNo = val)"
                                    @update:selected="(data) => (sendName = data)"></select-form> -->
                                <div id="dropdown" class="dropdown" @click="toggleDropdown">
                                    <div
                                        class="dropdown-selected"
                                        :class="{ highlight: selectedNumber && selectedNumber.is_present }"
                                    >
                                        <span v-if="selectedNumber">
                                            {{ selectedNumber.label }} {{ selectedNumber.value | phoneNumberFilter }}
                                        </span>
                                        <span
                                            v-if="selectedNumber && selectedNumber.is_present"
                                            class="highlight"
                                            :style="{ backgroundColor: '#4780fd', color: 'white' }"
                                        >
                                            대표
                                        </span>
                                        <span class="arrow down"></span>
                                    </div>
                                    <div class="dropdown-content" v-if="isOpen">
                                        <div
                                            v-for="option in options"
                                            :key="option.value"
                                            class="dropdown-option"
                                            :class="{ highlight: isHighlighted(option) }"
                                            @click="selectOption(option, $event)"
                                        >
                                            <span>{{ option.label }} {{ option.value | phoneNumberFilter }}</span>
                                            <span
                                                v-if="option.is_present"
                                                class="highlight"
                                                :style="{ backgroundColor: '#4780fd', color: 'white' }"
                                            >
                                                대표
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="sub-head">
                                자주 사용하는 문자
                                <span class="text-black-50">(선택)</span>
                            </span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="['선택', ...oftenList]"
                                    :select-value="['', ...oftenValList]"
                                    :selectedValue="selectedMsgTemplate"
                                    @update:set="oftenLoad"
                                ></select-form>
                            </div>
                        </div>

                        <div class="receive-box">
                            <span class="sub-head">
                                받는 사람
                                <span class="require">*</span>
                            </span>
                            <div class="line">
                                <div class="com-search-input">
                                    <!-- <input minlength="4" placeholder="회원명, 전화번호" required type="text"
                                        @input="onKeyupSearchKeyword" /> -->
                                    <input
                                        minlength="4"
                                        placeholder="회원명, 전화번호"
                                        required
                                        type="text"
                                        @input="onKeyupSearchKeyword"
                                        v-model="searchStr"
                                    />
                                    <button class="search-btn">검색</button>
                                </div>
                            </div>
                            <div class="line">
                                <select-check-form
                                    :select-data="['전체', '남자', '여자']"
                                    :select-value="['all', 'M', 'W']"
                                    :selected-value="sex"
                                    title="성별"
                                    @update:set="onChangeSexCode"
                                />
                                <select-check-form
                                    :select-data="['전체', '유효회원', '종료회원', '잠재회원', '홀딩회원']"
                                    :select-value="['all', 'V', 'E', '-', 'H']"
                                    :selected-value="searchValidTypes"
                                    title="회원유효여부"
                                    @update:set="onChangeValidGroup"
                                />
                                <select-check-form
                                    :select-data="['전체', ...memberGroupList]"
                                    :select-value="['all', ...memberGroupValueList]"
                                    :selected-value="searchTeamIds"
                                    title="회원그룹"
                                    @update:set="onChangeMemberGroup"
                                />
                                <select-check-form
                                    :select-data="['전체', '개인', '듀엣', '그룹', '쿠폰', 'OT', '회원권', '운동복']"
                                    :select-value="['all', 'P', 'D', 'G', 'C', 'O', 'T', 'S']"
                                    :selected-value="searchTicketTypes"
                                    title="이용권구분"
                                    @update:set="onChangeTicketCode"
                                />
                                <select-form
                                    :select-data="['이용권 유효여부', '유효', '만료']"
                                    :select-value="['', 'V', 'E']"
                                    :selected-value="searchTicketStatus"
                                    @update:set="onChangeTicketStatus"
                                />
                                <button class="com-search-reset" @click="reset"></button>
                            </div>
                            <div class="send-table">
                                <table class="com-table">
                                    <colgroup>
                                        <col style="width: 40px" />
                                        <col style="width: 400px" />
                                        <col style="width: 200px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div class="com-check">
                                                    <input
                                                        id="check-send-all"
                                                        v-model="selectAll"
                                                        name="check-send-all"
                                                        type="checkbox"
                                                        @click="(selectAll = !selectAll), all()"
                                                    />
                                                    <label for="check-send-all"></label>
                                                </div>
                                            </th>
                                            <th>회원명</th>
                                            <th>전화번호</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div class="table-scroll">
                                    <table class="com-table h25">
                                        <colgroup>
                                            <col style="width: 40px" />
                                            <col style="width: 400px" />
                                            <col style="width: 200px" />
                                        </colgroup>

                                        <tbody
                                            v-if="!showSeleted && paramArray !== 0 && memberList.length === 0"
                                            style="position: relative"
                                        >
                                            <tr v-for="(m, index) in paramArray" :key="m.index">
                                                <td>
                                                    <div class="com-check">
                                                        <input
                                                            :id="`check-user-${index}`"
                                                            v-model="selected"
                                                            :value="m"
                                                            name="check-send"
                                                            type="checkbox"
                                                        />
                                                        <label :for="`check-user-${index}`"></label>
                                                    </div>
                                                </td>
                                                <td>{{ m.name }}</td>
                                                <td>
                                                    {{ m.phone | customerPhoneFilter }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody
                                            v-if="!showSeleted && memberList.length !== 0"
                                            style="position: relative"
                                        >
                                            <tr v-for="(m, index) in nonEditableMembers" :key="m.index">
                                                <td>
                                                    <div class="com-check">
                                                        <input
                                                            :id="`check-user-${index}`"
                                                            v-model="selected"
                                                            :value="m"
                                                            name="check-send"
                                                            type="checkbox"
                                                        />
                                                        <label :for="`check-user-${index}`"></label>
                                                    </div>
                                                </td>
                                                <td>{{ m.name }}</td>
                                                <td>
                                                    {{ m.phone | customerPhoneFilter }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-show="showSeleted" style="position: relative">
                                            <tr v-for="(m, index) in filteredSelected" :key="index">
                                                <td>
                                                    <div class="com-check">
                                                        <input
                                                            :id="`check-user-${index}`"
                                                            :value="m"
                                                            checked
                                                            name="check-send"
                                                            onclick="return false;"
                                                            type="checkbox"
                                                            @click="removeFromSelected(index)"
                                                        />
                                                        <label :for="`check-user-${index}`"></label>
                                                    </div>
                                                </td>
                                                <td>{{ m.name }}</td>
                                                <td>
                                                    {{ m.phone | customerPhoneFilter }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody
                                            v-if="!showSeleted && paramArray == 0 && memberList.length === 0"
                                            style="position: relative"
                                        >
                                            <tr>
                                                <td v-if="memberList.length === 0" colspan="100">
                                                    등록된 내용이 없습니다.
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody style="position: relative">
                                            <tr
                                                v-for="(member, index) in editableMembers"
                                                :key="`editable-${member.id}`"
                                            >
                                                <td>
                                                    <div class="com-check">
                                                        <input
                                                            :id="`check-user-editable-${index}`"
                                                            type="checkbox"
                                                            v-model="selected"
                                                            :value="member"
                                                        />
                                                        <label :for="`check-user-editable-${index}`"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        v-model="member.name"
                                                        placeholder="이름 입력"
                                                        class="form-control"
                                                        style="width: 100%; border: none; text-align: center"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        :value="member.phone"
                                                        @input="updatePhone(member, $event.target.value)"
                                                        placeholder="전화번호 입력"
                                                        class="form-control"
                                                        style="width: 100%; border: none; text-align: center"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="line-wrap">
                                    <div class="bottom-btn">
                                        <button class="com-btn blue" @click="getReciver()">선택완료</button>
                                        <button class="com-btn red" @click="onDelete">삭제</button>
                                        <button class="com-btn" @click="duplicateNumberDelete">
                                            중복된 번호 지우기
                                        </button>
                                    </div>
                                    <div class="tit-ext">
                                        <span>
                                            선택
                                            <span class="txt-blue">{{ selected.length }}</span>
                                            /{{ memberList.length }}
                                        </span>
                                        <button class="com-btn white" @click="addDirectInputItem">+ 직접 입력</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SMS 충전 금액 -->
                <div class="com-table-wrap sms-charge">
                    <div class="top-title">
                        <span class="title">SMS 충전 금액</span>
                    </div>
                    <div class="cont-wrap">
                        <div class="top-area">
                            <div class="tit">
                                <div class="tooltip-wrap">
                                    <span>발송 예정/가능 건수</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <p class="txt">
                                                90byte 초과 시 LMS(장문)로 자동 전환되며, ‘[WEB] 발신 안내’는 글자 수에
                                                포함되지 않습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="tit-ext">
                                    <span>
                                        보유 SMS 금액
                                        <span class="txt-blue">{{ remains.point | numberFormatFilter }}</span>
                                        원
                                    </span>
                                    <button class="com-btn middle white" @click="payBtn">충전하기</button>
                                </div>
                            </div>
                            <div class="check"></div>
                        </div>

                        <table class="com-table">
                            <colgroup>
                                <col />
                                <col />
                                <col />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>SMS(단문)</th>
                                    <th>LMS(장문)</th>
                                    <th>MMS(사진)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ remains.sms | numberFormatFilter }}건</td>
                                    <td>{{ remains.lms | numberFormatFilter }}건</td>
                                    <td>{{ remains.mms | numberFormatFilter }}건</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="table-info float-right">SMS 12원/ LMS 35원/ MMS 90원</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn" @click="reset()">취소</button>
            <!-- <button class="com-btn green" @click="setSendType">예약 발송</button> -->
            <button class="com-btn blue" @click="sendMessage">발송하기</button>
        </div>

        <!-- 광고문자 발송 유의사항 레이어 팝업 -->
        <div v-show="advertNotiPop" class="layer-pop square" :style="{ zIndex: 33 }">
            <div class="view-content w500">
                <button class="close" @click="advertNotiPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">광고성 문자 발송 유의사항</p>
                    <div class="advert-noti-box">
                        <p class="pop-txt">
                            정보통신망법 제50조 제4항에 따라 영리 목적의 광고성 정보 전송 시 다음과 같이 표기 의무를
                            준수해야 합니다. 아래 내용을 꼭 확인하고 이용해주세요.
                        </p>
                        <div class="pop-msg">
                            <img src="../../../../public/img/icons/pop_msg.png" alt="" />
                            <p class="txt1">
                                광고성 정보가 시작되는 부분
                                <span class="txt-blue">(광고)</span>
                                표시
                            </p>
                            <p class="txt2">
                                전송자의 명칭, 전화번호 또는 주소 표기 (연락처가 회신번호가 동일 시 생략 가능)
                                <br />
                                <span class="txt-blue">OO센터, OO센터 신년 이벤트</span>
                            </p>
                            <p class="txt3">
                                메시지 하단 수신거부 및 수신동의 철회 방식 기재 및 명시
                                <br />
                                <span class="txt-blue">무료수신거부 080-560-5608</span>
                            </p>
                        </div>
                        <div class="info-wrap">
                            광고성 정보를 전송하면서 매체별 명시사항 및 명시방법을 준수하지 않은 자 뿐만 아니라 그러한
                            행위를 하도록 한 자의 경우에는 3천만 원 이하의 과태료가 부과됩니다.
                            <p>※ 정보통신망법 제76조 제1항 제8호</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- SMS 금액 충전 레이어 팝업 -->
        <div v-show="smsChargePop" class="layer-pop square" :style="{ zIndex: 33 }">
            <div class="view-content w600">
                <button class="close" @click="smsChargePop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">SMS 금액 충전</p>
                    <div class="sms-charge-pop">
                        <div class="info-wrap">
                            최소 충전 금액은 10,000원입니다. (부가세 제외)
                            <br />
                            충전금액을 ‘직접 입력’으로 선택하셨을 경우, 금액은 만 원 단위로 숫자만 입력 가능합니다.
                        </div>
                        <table class="com-table">
                            <tbody>
                                <tr>
                                    <th>
                                        센터명
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <input type="text" :value="centerInfo.centerName" readonly />
                                    </td>
                                </tr>
                                <tr>
                                    <th>보유 금액</th>
                                    <td class="won-text">
                                        <input type="text" :value="formatNumber(remains.point)" readonly />
                                    </td>
                                </tr>
                                <!-- 충전 금액 선택 -->
                                <tr>
                                    <th>
                                        충전 금액
                                        <span class="require">*</span>
                                    </th>
                                    <td>
                                        <select-form
                                            :select-data="chargeAmountOptions.data"
                                            :select-value="chargeAmountOptions.value"
                                            :selectedValue="selectedChargeAmount"
                                            @update:set="handleSelectedTextChange"
                                            @update:selected="handleChargeAmountChange"
                                        ></select-form>
                                    </td>
                                </tr>

                                <tr v-if="selectedChargeAmount === '직접입력'">
                                    <th>
                                        충전 금액
                                        <span class="require">*</span>
                                    </th>
                                    <td class="won-text">
                                        <input
                                            v-model="customChargeAmount"
                                            type="text"
                                            placeholder="금액을 입력하세요 (만원 단위)"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="table-info">
                            <strong>결제 진행 금액</strong>
                            <span class="amount">{{ formatNumber(finalChargeAmount) }}</span>
                            원 (부가세 포함)
                        </div>
                        <div class="com-check">
                            <input id="agreeCheckbox" name="agree" type="checkbox" v-model="isAgreed" />
                            <label for="agreeCheckbox">위 내용을 확인하였으며, 결제 진행에 동의합니다.</label>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="smsChargePop = false">취소</button>
                            <button @click="nicepayStart()" class="com-btn blue">다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SMS 예약발송 레이어 팝업 -->
        <div v-show="smsReservePop" class="layer-pop square" :style="{ zIndex: 33 }">
            <div class="view-content w400">
                <button class="close" @click="smsReservePop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">SMS 예약 발송</p>
                    <div class="sms-reserve-pop">
                        <div class="calendar-area">
                            <b-calendar
                                v-model="selectedDate"
                                :disabled="sendType === 'N'"
                                @input="datePick"
                            ></b-calendar>
                            <select-form
                                :style="{ zIndex: 35 }"
                                :disabled="sendType == 'N'"
                                :select-data="selectFormStartHour.data"
                                :select-value="selectFormStartHour.value"
                                :selected-value="selectFormStartHour.selectedValue"
                                class="w100"
                                @update:set="(val) => (selectFormStartHour.selectedValue = val)"
                            ></select-form>
                            <span class="txt">시</span>
                            <select-form
                                :style="{ zIndex: 35 }"
                                :disabled="sendType == 'N'"
                                :select-data="selectFormStartMin.data"
                                :select-value="selectFormStartMin.value"
                                :selected-value="selectFormStartMin.selectedValue"
                                class="w100"
                                @update:set="(val) => (selectFormStartMin.selectedValue = val)"
                            ></select-form>
                            <span class="txt">분</span>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="smsReservePop = false">취소</button>
                            <button class="com-btn blue" @click="sendMessage">예약</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="loading-indicator">Loading...</div>
        <!-- 결제관련 폼 -->
        <!-- <iframe name="hiddenFrame" style="display: none"></iframe> -->
        <form name="payForm" method="post" :action="paymentActionUrl" class="nicePay">
            <table>
                <tr>
                    <th>PayMethod</th>
                    <td>
                        <input type="hidden" name="PayMethod" value="CARD, VBANK" />
                    </td>
                </tr>
                <tr>
                    <th>GoodsName</th>
                    <td><input type="hidden" name="GoodsName" value="SMS 충전" /></td>
                </tr>
                <tr>
                    <th>Amt</th>
                    <td>
                        <input type="hidden" name="Amt" v-model="finalChargeAmount" />
                    </td>
                    <!-- <td><input type="text" name="Amt" v-model=sampleAmt /></td> -->
                </tr>
                <tr>
                    <th>MID</th>
                    <td>
                        <input type="hidden" name="MID" v-model="MID" />
                    </td>
                </tr>
                <tr>
                    <th>Moid</th>
                    <td>
                        <input type="hidden" name="Moid" v-model="Moid" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerName</th>
                    <td>
                        <input type="hidden" name="BuyerName" v-model="uName" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerEmail</th>
                    <td>
                        <input type="hidden" name="BuyerEmail" v-model="staffEmail" />
                    </td>
                </tr>
                <tr>
                    <th>BuyerTel</th>
                    <td>
                        <input type="hidden" name="BuyerTel" value="" />
                    </td>
                </tr>
                <tr>
                    <th>ReturnURL [Mobile only]</th>
                    <td>
                        <input type="hidden" name="ReturnURL" value="" />
                    </td>
                </tr>
                <tr>
                    <th>Virtual Account Expiration Date(YYYYMMDD)</th>
                    <td>
                        <input type="hidden" name="VbankExpDate" :value="nextWeekDate" />
                    </td>
                </tr>

                <input type="hidden" name="NpLang" value="KO" />
                <!-- EN:English, CN:Chinese, KO:Korean -->
                <input type="hidden" name="GoodsCl" value="1" />
                <!-- products(1), contents(0)) -->
                <input type="hidden" name="TransType" value="0" />
                <!-- USE escrow false(0)/true(1) -->
                <input type="hidden" name="CharSet" value="utf-8" />
                <!-- Return CharSet -->
                <input type="hidden" name="ReqReserved" value="" />
                <!-- mall custom field -->
                <!-- <input type="hidden" name="ConnWithIframe" value="Y" /> -->
                <input type="hidden" name="ConnWithIframe" value="N" />
                <!-- DO NOT CHANGE -->
                <input type="hidden" name="EdiDate" ref="ediDateInput" :value="ediDate" />
                <!-- YYYYMMDDHHMISS -->
                <!-- <input type="hidden" name="SignData" v-model="signData" /> -->
                <input type="hidden" name="SignData" ref="signDataInput" />
                <!-- signData -->
                <input type="hidden" name="VbankExpDate" value="20240324" />
            </table>
            <a href="#" class="btn_blue" onClick="nicepayStart();">REQUEST</a>
        </form>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import Vue from 'vue';

window.completePayment = function (childWindow, ResultCode, ResultMsg) {
    console.log('completePayment');
    childWindow.close();
    setTimeout(() => {
        alert(ResultMsg);
        // alert('결제가 완료되었습니다.');
        window.location.reload();
    }, 150);
};
window.nicepaySubmit = function () {
    // 결제 양식을 제출합니다.
    document.payForm.submit();
};
window.nicepayClose = function () {
    alert('결제가 취소 되었습니다');
};

export default {
    name: 'messageSend',
    props: {},
    computed: {
        paymentActionUrl() {
            return `${process.env.VUE_APP_PAYMENT_API_URL}/admin/api/payment/approvalRequest`;
        },
        num() {
            const str = this.getMessageContent(); // 내용
            const str_len = str.length; // 길이

            let rbyte = 0;
            let rlen = 0;
            let one_char = '';
            let maxByte = 0;
            if (this.msgType === 'S') {
                maxByte = 90;
            } else if (this.msgType === 'L') {
                maxByte = 2000;
            } else if (this.msgType === 'M') {
                maxByte = 2000;
            }
            for (let i = 0; i < str_len; i++) {
                one_char = str.charAt(i); // char 단위로 구분해서 바이트 구분
                if (/[\u3131-\uD79D]/giu.test(one_char)) {
                    // 한글
                    rbyte += 2;
                } else if (/[~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]/.test(one_char)) {
                    // 특수문자
                    rbyte += 2;
                    // } else if (/[\u1F600-\u1F64F]/g.test(one_char)) { // 이모티콘
                    // rbyte += 4;
                } else {
                    rbyte++; // 영문등 나머지
                }
                if (rbyte <= maxByte) {
                    rlen = i + 1; // return 할 문자열 갯수
                }
            }
            // 넘어가는 글자는 자른다
            if (rbyte > maxByte) {
                return str
                    .split('')
                    .map((s) => s.charCodeAt(0))
                    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
            } else if ((maxByte = 0)) {
                alert('문자 형식을 선택 해주세요.');
            } else {
                return rbyte;
            }
        },
        totalNum() {
            if (this.msgType === 'S') {
                return 90;
            } else if (this.msgType === 'L') {
                return 2000;
            } else if (this.msgType === 'M') {
                return 2000;
            }
            return 90;
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        uName() {
            const { getters } = this.$store;
            return getters['auth/userName'];
        },
        staffEmail() {
            const { getters } = this.$store;
            return getters['auth/staffEmail'];
        },
        staffId() {
            return this.$store.getters['auth/staffId'];
        },
        roleName() {
            const { getters } = this.$store;
            return getters['auth/roleName'];
        },
        estimatedAmount() {
            let unitPrice = 0;
            switch (this.msgType) {
                case 'S':
                    unitPrice = 8.4;
                    break;
                case 'L':
                    unitPrice = 25;
                    break;
                case 'M':
                    unitPrice = 60;
                    break;
                case 'K':
                    unitPrice = 8.4;
                    break;
            }

            const count = this.selected.length;

            return Math.floor(unitPrice * count * 10) / 10;
        },
        messageTypeAndLength() {
            const smsLimit = 90;
            const lmsMmsLimit = 2000;
            let length = 0;
            let type = 'S'; // 기본값 SMS
            let maxByte = smsLimit; // 기본 최대 바이트 SMS
            // 메시지 길이 계산
            for (let i = 0; i < this.content.length; i++) {
                const charCode = this.content.charCodeAt(i);
                if (charCode > 127 || charCode === 10) {
                    length += 2; // 한글 또는 특수문자
                } else {
                    length += 1; // 영문 또는 숫자
                }
            }
            // 메시지 타입 결정
            if (length <= smsLimit) {
                type = 'S';
                maxByte = smsLimit;
            } else {
                type = 'L'; // 여기에서 이미지 첨부 여부를 확인하여 MMS로 변경
                maxByte = lmsMmsLimit;
            }
            // 이미지 첨부 여부에 따라 MMS로 설정
            if (this.images && this.images.length > 0) {
                type = 'M';
            }
            if (this.msgType === 'K') {
                type = 'K';
            }
            this.msgType = type;
            return { type, length, maxByte };
        },
        messageTypeDisplay() {
            switch (this.messageTypeAndLength.type) {
                case 'S':
                    return 'SMS';
                case 'L':
                    return 'LMS';
                case 'M':
                    return 'MMS';
                case 'K':
                    return 'KAKAO';
                default:
                    return this.messageTypeAndLength.type;
            }
        },
        finalChargeAmount() {
            let amount = 0;
            // '직접입력' 선택 시 사용자가 입력한 금액을 사용
            if (this.selectedChargeAmount === '직접입력') {
                // 사용자 입력값이 문자열인지 확인하고, 문자열로 변환
                const inputAmount = String(this.customChargeAmount);
                amount = parseFloat(inputAmount.replace(/,/g, '')) || 0;
            } else {
                // 선택된 금액 옵션 사용
                const selectedAmount = String(this.selectedChargeAmount);
                amount = parseFloat(selectedAmount.replace(/,/g, '')) || 0;
            }
            const finalAmount = amount + amount * this.taxRate;
            return Math.round(finalAmount);
        },
        editableMembers() {
            return this.memberList.filter((member) => member.isEditable);
        },
        nonEditableMembers() {
            return this.memberList.filter((member) => !member.isEditable && !member.isDirectInput);
        },
        filteredSelected() {
            return this.selected.filter((item) => !item.isDirectInput);
        },
        fullAdvertText() {
            if (this.selectedCenterName === '직접 입력') {
                return `(광고) ${this.userInput}`;
            }
            return `(광고) ${this.selectedCenterName}`;
        },
        // 테스트셀렉트폼
        selectedLabel() {
            return this.selected ? this.selected.label : '선택해주세요';
        },
    },

    centerSelected() {
        const defaultOption = this.centerInfo && this.centerInfo.centerName ? this.centerInfo.centerName : '기본센터명';
        return [defaultOption, '직접입력'];
    },
    watch: {
        searchTicketTypes(newValue) {
            // 이용권구분
            this.searchTicketTypes = newValue;
            this.showSeleted = false;
            this.resetSearchKeyword();
            this.searchByFilter();
        },
        // 이용권 유효여부
        searchTicketStatus(newValue) {
            this.resetSearchKeyword();
            this.searchByFilter();
        },
        searchTeamIds(newValue) {
            // 회원그룹
            this.searchTeamIds = newValue;
            this.resetSearchKeyword();
            this.searchByFilter();
        },
        sex(newValue) {
            // 성별
            this.sex = newValue;
            this.showSeleted = false;
            this.resetSearchKeyword();
            this.searchByFilter();
        },
        searchValidTypes(newValue) {
            this.searchValidTypes = newValue;
            this.showSeleted = false;
            this.resetSearchKeyword();
            this.searchByFilter();
        },
        selected(val) {
            if (val.length === 0) {
                this.selectAll = false;
            }
        },
        content(val) {
            if (this.num > 89 && this.msgType === 'S') {
                this.msgType = 'L';
            } else if (this.num <= 89 && this.msgType === 'L') {
                this.msgType = 'S';
            }
        },
        selectedChargeAmount(newValue) {
            console.log('selectedChargeAmount changed to:', newValue);
        },
        customChargeAmount(newValue) {
            console.log('사용자가 입력한 금액:', newValue);
            const numericValue = newValue.replace(/[^\d,]/g, '');
            // 제거된 문자가 있으면 업데이트
            if (newValue !== numericValue) {
                this.customChargeAmount = numericValue;
            }
        },
        selectedCenterName(newVal) {
            if (newVal !== '직접 입력') {
                this.advertText.prefix = `(광고) ${newVal}\n`;
            } else {
                this.updateAdvertPrefix();
            }
        },
        userInput(newVal) {
            if (this.selectedCenterName === '직접 입력') {
                this.updateAdvertPrefix();
            }
        },
        userText(newVal) {
            if (this.selectedCenterName === '직접 입력') {
                this.advertText.prefix = `(광고) ${newVal}\n`;
            }
        },
        options: {
            immediate: true,
            handler() {
                const defaultOption = this.options.find((o) => o.is_present);
                if (defaultOption) this.selectedNumber = defaultOption;
            },
        },
    },

    data() {
        return {
            obj: '',
            msgType: 'S',
            advertNotiPop: false,
            smsChargePop: false,
            smsReservePop: false,
            smsReservePopPop: false,
            content: '',
            memberList: [],
            checked: [],
            centerId: '',
            roleId: '',

            centerNames: [], // 센터명과 "직접 입력"을 담을 배열
            selectedCenterName: '', // 선택된 센터명의 초기값

            genderList: ['전체', '남자', '여자'],
            genderTypeValueList: ['', 'M', 'W'],
            validList: ['유효회원', '종료회원', '잠재회원', '홀딩회원'],
            validTypeValueList: ['V', 'E', '-', 'H'],
            ticketList: ['전체', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복'],
            ticketTypeValueList: ['', 'P', 'O', 'D', 'G', 'C', 'T', 'S'],
            searchStr: '',
            selected: [],
            selectAll: false,
            sortSend: [],
            sortSendNo: [],
            sendName: '',
            sendNo: '',
            sex: [],
            url: null,
            images: [],
            multiple: true,
            group: '',
            ticket: '',
            vaild: '',
            sendType: 'N', // 발송타입

            startDate: moment().format('yyyy-MM-DD'),

            pagingInfo: { ...pagingInfo },
            // 시간관련 데이터
            selectFormStartHour: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectFormStartMin: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            imageFile: [],

            oftenList: [],
            oftenValList: [],
            imagesList: [],
            searchTicketTypes: [], // 이용권 구분 (P, O, D, G, C, T)
            searchTicketStatus: '',
            memberGroupList: [],
            memberGroupValueList: [],
            searchTeamIds: [],
            searchValidTypes: [],
            centerInfo: {},
            remains: {
                lms: 0,
                mms: 0,
                sms: 0,
                kakao: 0,
            },
            msgNoticePop: false,
            // 이전화면에서 가지고 온 파람들..
            paramArray: [],
            hasMessageEvent: false, // 권한에 따른 메세지 발송 버튼
            showSeleted: false,
            isAdvertEnabled: false, // 광고문자 설정 활성화 상태
            originalContent: '', // 광고문자 설정 활성화 상태에서 변경 전 내용
            userText: '',
            advertText: {
                // 광고문자 관련 텍스트 설정
                prefix: '(광고)\n',
                suffix: '\n무료수신거부 080-560-5608',
            },
            selectedCenter: {
                data: [],
                value: [],
                selectedCenterValue: '',
            },
            directInputValue: '', // 사용자가 '직접입력'을 선택했을 때 입력하는 값
            member: [],
            directEntryVisible: false,
            directEntry: { name: '', phone: '' },
            selectedChargeAmount: '', // 선택된 충전 금액
            customChargeAmount: '', // 사용자가 입력한 충전 금액
            chargeAmountOptions: {
                data: ['10,000원(최소결제금액)', '30,000원', '50,000원', '100,000원', '직접입력'],
                value: ['10,000원(최소결제금액)', '30,000원', '50,000원', '100,000원', '직접입력'],
                selectedChargeAmount: '',
            },
            taxRate: 0.1, // 부가세율
            isAgreed: false,
            ediDate: '',
            points: 0,
            Moid: '',
            MID: process.env.VUE_APP_NICE_PAY_MID,
            merchantKey: process.env.VUE_APP_NICE_PAY_KEY,
            // 테스트키
            // MID: "nicepay00m",
            // merchantKey: "EYzu8jGGMfqaDEp76gSckuvnaHHu+bC4opsSN6lHv3b2lurNYkVXrZ7Z1AoqQnXI3eLuaUFyoRNC6FkrzVjceg==",
            signData: '',
            paymentMessage: null,
            selectedMonth: null,
            selectedDate: moment().format('YYYY-MM-DD'),
            userInput: '',
            role: {},
            permissions: {}, // 권한
            rawPhone: '',
            defaultSendNo: '',

            // 테스트
            isOpen: false,
            testSelected: null,
            options: [],
            selectedNumber: null,
            selectedMsgTemplate: '',
            isLoading: false,
            nextWeekDate: this.getNextWeekDate(),
        };
    },
    created() {
        this.fetchRoleData();
    },
    mounted() {
        try {
            if (this.$route.params.data === undefined) {
                this.paramArray = [];
            } else {
                this.paramArray = this.$route.params.data;
                this.$route.params.data.map((elements) => {
                    this.selected.push(elements);
                });
            }
        } catch (error) {
            this.paramArray = [];
        }
        this.centerId = this.cId; // 센터id
        this.roleId = this.roleName; // 권한
        this.uName2 = this.uName; // 유저이름
        this.init();
        this.fetchRoleData();
        this.sendNo = this.defaultSendNo;
    },
    methods: {
        getReciver() {
            this.showSeleted = !this.showSeleted;
        },
        getNextWeekDate() {
            const date = new Date();
            date.setDate(date.getDate() + 7); // 일주일을 더함

            const year = date.getFullYear();
            const month = `0${date.getMonth() + 1}`.slice(-2); // 월은 0부터 시작하므로 1을 더함
            const day = `0${date.getDate()}`.slice(-2);

            return `${year}${month}${day}`;
        },
        // 테스트 셀렉트폼
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option, event) {
            event.stopPropagation(); // 이벤트 버블링 중지
            this.selectedNumber = option;
            this.sendNo = option.value;
            this.isOpen = false;
        },

        isHighlighted(option) {
            // 강조 표시가 필요한 조건을 여기에 정의
            return option && option.is_present;
        },
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await Promise.allSettled([
                this.onMessageTemplate(),
                this.fetchRemainInfo(),
                this.fetchMemberGroupList(),
                this.onCallNumber(),
                this.loadCallNumbers(),
            ]);
            const { selectFormStartHour, selectFormStartMin } = this;
            // 시작 시간 : 시
            for (let h = 0; h < 24; h++) {
                const hour = h.toString().padStart(2, '0');
                selectFormStartHour.data.push(hour);
                selectFormStartHour.value.push(hour);
            }
            // 시작 시간 : 분
            const timeUnitValue = 1;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    const min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }

            this.sendNo = this.defaultSendNo;
            this.sendName = this.sortSend[0];
        },
        async fetchRemainInfo() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}`);
                // const { data: countData } = await api.get(`/admin/api/center/${this.centerId}/message/sms/count`);
                const { data: pointData } = await paymentApi.get(`/admin/api/payment/point/${this.centerId}`);
                this.centerInfo = data;
                console.log('centerInfo', this.centerInfo);

                // 센터명과 "직접 입력"을 centerNames 배열에 추가
                this.centerNames = [this.centerInfo.centerName, '직접 입력'];
                // 선택된 센터명의 초기값 설정
                this.selectedCenterName = this.centerInfo.centerName;

                const { remains } = this;
                const points = pointData.point || 0; // 사용 가능한 포인트
                // 각 메시지 타입별 단가
                const smsPrice = 12;
                const lmsPrice = 35;
                const mmsPrice = 90;
                const kakaoPrice = 12;
                // 각 메시지 타입별 최대 보낼 수 있는 메시지 수 계산
                const maxSmsCount = Math.floor(points / smsPrice);
                const maxLmsCount = Math.floor(points / lmsPrice);
                const maxMmsCount = Math.floor(points / mmsPrice);
                const maxKakaoCount = Math.floor(points / kakaoPrice);

                // 계산된 값으로 remains 객체 업데이트
                this.remains.sms = maxSmsCount;
                this.remains.lms = maxLmsCount;
                this.remains.mms = maxMmsCount;
                this.remains.kakao = maxKakaoCount;
                this.remains.point = points; // 남은 포인트도 업데이트
            } catch (e) {}
        },
        // 중복번호 삭제
        duplicateNumberDelete() {
            if (this.paramArray.length === 0 && this.memberList.length === 0) {
                return;
            }
            this.selected = [];
            const test = this.memberList;
            this.memberList = test.filter(
                (item1, idx1) => test.findIndex((item2, idx) => item1.phone == item2.phone) == idx1
            );

            if (this.paramArray.length !== 0) {
                const test2 = this.paramArray;
                this.paramArray = test2.filter(
                    (item1, idx1) =>
                        // filter() 메서드는 콜백함수에서 정의한 조건이 true인 항목만 리턴한다.(필터링)
                        test2.findIndex(
                            (item2, idx) =>
                                // findIndex() 메서드는 콜백함수에 정의한 조건이 true인 항목의 index를 리턴한다.
                                item1.phone == item2.phone
                        ) == idx1
                );
            }

            this.selectAll = false;

            alert('중복번호를 제거하였습니다.');
        },

        // 이벤트 발생시 키워드 길이 체크
        onKeyupSearchKeyword(e) {
            console.log(e.target.value);
            this.searchStr = e.target.value;
            this.searchByKeyword();
        },
        searchByKeyword() {
            this.showSeleted = false;
            if (this.searchStr.length === 0) {
                // 검색어가 없는 경우, 목록을 비운다.
                this.memberList = [];
                return;
            }

            // 키워드 외 검색 필터 리셋
            if (this.sex.length > 0) {
                this.sex = [];
            }
            if (this.searchTeamIds.length > 0) {
                this.searchTeamIds = [];
            }
            if (this.searchTicketTypes.length > 0) {
                this.searchTicketTypes = [];
            }
            if (this.searchTicketStatus) {
                this.searchTicketStatus = '';
            }
            if (this.searchValidTypes.length > 0) {
                this.searchValidTypes = [];
            }

            this.onMemberList();
        },
        searchByFilter() {
            this.onMemberList();
        },
        // 체크박스 전체선택 이벤트
        all() {
            if (this.showSeleted && this.selected.length === 0) {
                return;
            }

            try {
                this.selected = [];
                if (this.selectAll) {
                    for (const member of this.memberList) {
                        this.selected.push(member);
                    }

                    if (this.paramArray.length !== 0 && this.searchStr === '') {
                        for (const member of this.paramArray) {
                            this.selected.push(member);
                        }
                    }
                } else {
                    this.selectAll = !this.selectAll;
                }
            } catch (error) {}
        },
        // 발신번호 호출
        async onCallNumber() {
            try {
                this.isLoading = true;
                const { data } = await this.getMessageChargeCall();
                console.log('발신번호', data);
                data.forEach((g) => {
                    const senderName = g.isPresent ? `${g.senderName} (대표)` : g.senderName;
                    const formattedSenderNo = this.formatPhoneNumber(g.senderNo); // senderNo를 formatPhoneNumber 함수로 처리
                    const senderInfo = `${senderName} ${formattedSenderNo}`; // formattedSenderNo를 사용
                    this.sortSend.push(senderInfo);
                    this.sortSendNo.push(formattedSenderNo); // formattedSenderNo를 사용
                    if (g.isPresent) {
                        this.defaultSendNo = formattedSenderNo; // formattedSenderNo를 사용
                    }
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getMessageChargeCall() {
            return api.get(`admin/api/center/${this.centerId}/message/phone?`, {
                params: {
                    // ...this.pagingInfo,
                },
            });
        },
        async loadCallNumbers() {
            try {
                const response = await paymentApi.post(`admin/api/center-phone/${this.centerId}/list`, {
                    page: 1,
                    skip: 10,
                });
                // 응답 데이터를 드롭다운 옵션 형식으로 매핑
                this.options = response.data.list
                    .filter((item) => item.is_validated === 'APPROVED') // is_validated 값이 "APPROVED"인 항목만 선택
                    .map((item) => ({
                        label: item.send_nm,
                        value: item.send_no,
                        is_present: item.is_present,
                        is_sub_number: item.is_sub_number,
                    }));

                // 기본 선택값 설정
                const defaultOption = this.options.find((o) => o.is_present);
                if (defaultOption) this.selectedNumber = defaultOption;

                console.log('loadCallNumbers', this.options);
            } catch (error) {
                console.error(error);
            }
        },
        formatPhoneNumber(value) {
            if (value) {
                const phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
                if (phone.length === 11) {
                    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 10) {
                    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 9) {
                    return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                }
            }
            return value;
        },

        // 담당 회원 API 호출
        async onMemberList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                // this.setPageParams(data, 'center');
                if (data.length != this.selected.length && data.length != 0) {
                    this.selectAll = false;
                }
                this.memberList = data;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('담당 회원 조회시 오류가 발생했습니다.');
            }
        },
        // 센터 회원 조희
        getCenterList() {
            const { sex, searchTeamIds, searchStr, searchTicketTypes, searchValidTypes, searchTicketStatus } = this;

            const searchParams = {};

            if (searchStr.trim() !== '') {
                searchParams.nameOrPhone = searchStr.trim();
            } else {
                const sexes = this.removeAllStringFromArray(sex).join(',');
                const centerTeamIds = this.removeAllStringFromArray(searchTeamIds).join(',');
                const ticketTypes = this.removeAllStringFromArray(searchTicketTypes).join(',');
                const statuses = this.removeAllStringFromArray(searchValidTypes).join(',');

                let isExistFilter = false;

                if (sexes.length > 0) {
                    searchParams.sexes = sexes;
                    isExistFilter = true;
                }
                if (centerTeamIds.length > 0) {
                    searchParams.centerTeamIds = centerTeamIds;
                    isExistFilter = true;
                }
                if (ticketTypes.length > 0) {
                    searchParams.ticketTypes = ticketTypes;
                    isExistFilter = true;
                }
                if (searchTicketStatus) {
                    searchParams.ticketStatus = searchTicketStatus;
                    isExistFilter = true;
                }
                if (statuses.length > 0) {
                    searchParams.statuses = statuses;
                    isExistFilter = true;
                }

                if (!isExistFilter) {
                    // 필터 조건이 아무것도 없으면,
                    return { data: [] };
                }
            }
            // 스웨거 검색: 센터회원 조회(문자발송)
            return api.get(`/admin/api/center/${this.centerId}/customer/message`, {
                params: {
                    ...searchParams,
                    ...this.pagingInfo,
                },
            });
        },
        onDelete() {
            this.selected.forEach((g) => {
                if (this.paramArray !== undefined) {
                    this.paramArray = this.paramArray.filter((val) => val.centerCustomerId !== g.centerCustomerId);
                }

                this.memberList = this.memberList.filter((val) => val.centerCustomerId !== g.centerCustomerId);
            });
            console.log(this.paramArray, this.memberList);
            // selected를 빈배열로 만든다.
            this.selected = [];
        },
        fnChkByte(e) {
            this.content = e.target.value;
        },
        readUrl(e) {
            Array.from(e.target.files).forEach((file) => {
                if (file) {
                    if (!file.type.match('image/jpeg')) {
                        alert('jpg 또는 jpeg 형식의 파일만 업로드 가능합니다.');
                        return;
                    }
                    // 파일 크기 제한 (예: 200KB)
                    const maxSize = 200 * 1024; // 200KB
                    if (file.size > maxSize) {
                        alert('파일 크기가 너무 큽니다. 200KB 이하의 파일만 업로드 가능합니다.');
                        return;
                    }
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.onload = () => {
                            // 가로 세로 크기 제한
                            const maxDimensionWidth = 1500; // 1500px
                            const maxDimensionHeight = 1440; // 1440px
                            if (img.width > maxDimensionWidth || img.height > maxDimensionHeight) {
                                alert(
                                    '이미지의 가로 또는 세로 크기가 너무 큽니다. 1500x1440px 이하의 크기만 업로드 가능합니다.(1280x720이하권장) '
                                );
                                return;
                            }
                            if (Array.isArray(this.images)) {
                                this.images.push({ url: e.target.result });
                                this.imagesList.push({
                                    fileName: file.name, // 파일 이름
                                    mimetype: file.type, // 'blob', // MIME 타입을 "blob"으로 설정
                                    base64data: e.target.result.split(',')[1], // Base64 인코딩된 이미지 데이터
                                    src: e.target.result, // 전체 Base64 URL
                                });
                            }
                        };
                        img.src = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            });
            this.imageFile = Array.from(e.target.files);
            e.target.value = '';
        },

        deleteImage(index) {
            // this.images 배열에서 이미지 삭제
            if (this.images && this.images.length > index) {
                this.images.splice(index, 1);
            }

            // this.imagesList 배열에서도 동일한 인덱스의 이미지 정보 삭제
            if (this.imagesList && this.imagesList.length > index) {
                this.imagesList.splice(index, 1);
            }
        },
        getMessageContent() {
            let messageContent = this.content;
            if (this.isAdvertEnabled) {
                messageContent = `${this.advertText.prefix}${this.content}${this.advertText.suffix}`;
            }
            return messageContent;
        },
        getMsgParams(chunk) {
            const users = [];
            chunk.forEach((g) => {
                users.push({
                    customerId: g.centerCustomerId,
                    no: g.phone,
                    name: g.name,
                });
            });
            let reserveDate = '';
            if (this.sendType === 'R') {
                // 예약 발송일 경우 선택한 날짜와 시간을 'YYYYMMDDHHmmss' 형식으로 설정
                const formattedReserveDate = moment(
                    `${this.startDate} ${this.selectFormStartHour.selectedValue}:${this.selectFormStartMin.selectedValue}`
                );

                // 현재 시간과 예약 시간 비교
                if (formattedReserveDate.isBefore(moment())) {
                    alert('예약 시간은 현재 시간보다 이전으로 설정할 수 없습니다.');
                    return;
                }

                reserveDate = formattedReserveDate.format('YYYYMMDDHHmmss');
            }
            // 광고 문자 설정에 따른 메시지 내용 처리
            const messageContent = this.getMessageContent();
            const params = {
                smsType: this.msgType,
                content: messageContent,
                reserveDate,
                sendNo: this.sendNo, // 발신정보
                sendName: this.uName, // 발송자(직원)
                recvInfos: users,
            };
            // MMS면서 이미지가 있는 경우.
            if (this.msgType === 'M' && this.imagesList.length > 0) {
                this.imagesList.forEach((image, index) => {
                    params[`imageFile${index + 1}`] = {
                        fileName: image.fileName,
                        mimetype: image.mimetype,
                        base64data: image.base64data,
                    };
                });
            }
            console.log('params', params);
            return params;
        },
        async sendMessage() {
            switch (this.msgType) {
                case 'S':
                    if (this.remains.sms < this.selected.length) {
                        alert('발송가능건수 보다 많습니다.');
                        return;
                    }
                    break;
                case 'L':
                    if (this.remains.lms < this.selected.length) {
                        alert('발송가능건수 보다 많습니다.');
                        return;
                    }
                    break;
                case 'M':
                    if (this.remains.mms < this.selected.length) {
                        alert('발송가능건수 보다 많습니다.');
                        return;
                    }
                    break;
                case 'K':
                    if (this.remains.kakao < this.selected.length) {
                        alert('발송가능건수 보다 많습니다.');
                        return;
                    }
                    break;
            }
            console.log('this.permissions', this.permissions);
            if (!this.permissions.ME_EVENT_001) {
                alert('메시지 발송 권한이 없습니다.');
                return;
            }
            try {
                // 내용검사
                const validate = this.validateReturnValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                // 선택된 사용자를 100명씩 분할
                const chunks = [];
                // for (let i = this.selected.length; i > -500; i -= 500) {
                //     i = i < 0 ? 0 : i;
                //     chunks.push(this.selected.slice(Math.max(i - 500, 0), i));
                // }
                chunks.push(this.selected);

                for (const chunk of chunks) {
                    const params = this.getMsgParams(chunk);
                    if (params === null) {
                        // getMsgParams에서 예약 시간 검증 실패
                        return; // 메시지 발송 중단
                    }

                    // 메시지를 보내고 4초 대기 없이 바로 다음 메시지 발송
                    this.getSendMessage(params);
                }

                this.selected = [];
                this.content = '';
                this.reset();
                const message = '발송하였습니다.';
                alert(message);
            } catch (error) {
                this.reset();
                this.selected = [];
                this.content = '';
                console.error(error);
            } finally {
                this.isLoading = false; // 로딩 종료
            }
        },

        // 파라미터 validate
        validateReturnValues() {
            // 필수값 체크
            let result = false;
            const { msgType, content, sendNo, sendName, selected } = this;
            let msg = '';
            // 제목
            // 메세지내용
            if (content === '' || content === undefined) {
                msg = '내용을 입력하세요.';
                return { result, msg };
            }
            // 보내는사람
            if (sendNo === '' || sendNo === undefined) {
                msg = '보내는사람을 선택하세요.';
                return { result, msg };
            }

            // 보내는사람
            if (sendName === '' || sendName === undefined) {
                msg = '보내는사람을 입력하세요.';
                return { result, msg };
            }
            // 받는사람
            if (selected.length == 0) {
                msg = '받는사람을 선택하세요.';
                return { result, msg };
            }

            // 메시지 바이트 수 확인
            const messageByte = this.num; // computed 프로퍼티 접근 방식
            const maxByte = this.totalNum; // computed 프로퍼티 접근 방식
            if (messageByte > maxByte) {
                msg = `${maxByte}byte 이상의 메세지는 보낼 수 없습니다.`;
                return { result, msg };
            }
            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        getSendMessage(params) {
            // 스웨거 검색: 메시지발송 등록
            // return api.post(`/admin/api/center/${this.centerId}/message/sms/register`, params);
            return paymentApi
                .post(`/admin/api/sms/${this.centerId}/register`, params)
                .then((response) => {
                    console.log(response);
                    return response;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        datePick(val) {
            console.log('선택된 날짜:', val);
            console.log(moment(val).diff(moment(), 'days'));
            this.selectedDate = val;
            this.startDate = val;
            if (this.sendType == 'R' && moment(val).diff(moment(), 'days') < 0) {
                this.startDate = moment().format('YYYY-MM-DD');
                alert('발송시에는 현재날짜보다 이전으로 설정할수 없습니다.');
            }
        },
        // 자주쓰는문자 템플릿
        async onMessageTemplate() {
            try {
                const { data } = await this.getMessageTemplate();
                data.forEach((g) => {
                    this.oftenList.push(g.title);
                    this.oftenValList.push(g.messageTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getMessageTemplate() {
            return api.get(`/admin/api/center/${this.centerId}/message/template`, {
                params: {
                    auto: false,
                },
            });
        },
        // 자주쓰는 문자 불러오기
        async oftenLoad(val) {
            try {
                if (val === undefined || val === '' || val == null) {
                    // 초기화
                    this.msgType = 'S';
                    this.content = '';
                    this.selectedMsgTemplate = '';

                    return;
                }
                const { data } = await this.fetchOftenLoad(val);
                this.content = data.content;
                this.msgType = data.smsType;
                this.selectedMsgTemplate = val;
                console.log('data', data);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        fetchOftenLoad(messageTemplateId) {
            // 스웨거 검색: 메시지템플릿 조회
            return api.get(`/admin/api/center/${this.centerId}/message/template/${messageTemplateId}`);
        },
        // 센터회원팀 목록 조회
        async fetchMemberGroupList() {
            try {
                const { data } = await this.sendGetMemberGroupList();
                data.forEach((g) => {
                    this.memberGroupList.push(g.c_center_cust_team_nm);
                    this.memberGroupValueList.push(g.c_center_cust_team_id);
                });
            } catch (error) {
                console.log('회원그룹을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원팀 API 호출
        sendGetMemberGroupList() {
            return api.get(`/admin/api/center/${this.centerId}/customer-team`);
        },

        resetSearchKeyword() {
            if (this.searchStr.length > 0) {
                this.searchStr = '';
            }
        },
        // 성별 선택시
        onChangeSexCode(val) {
            this.sex = val;
        },
        // 이용권 구분 체크 변경시
        onChangeTicketCode(val) {
            this.searchTicketTypes = val;
        },
        // 이용권 유효여부 변경시
        onChangeTicketStatus(val) {
            this.searchTicketStatus = val;
        },
        // 유효기간 변경시
        onChangeValidGroup(val) {
            this.searchValidTypes = val;
        },
        // 회원그룹 체크 변경시
        onChangeMemberGroup(val) {
            this.searchTeamIds = val;
        },
        setSendType() {
            const validation = this.validateReturnValues();
            // 유효성 검사 결과 확인
            if (validation.result) {
                // 유효성 검사를 통과한 경우
                this.sendType = 'R';
                this.smsReservePop = true;
                console.log('sendType:', this.sendType);
            } else {
                // 유효성 검사를 통과하지 못한 경우
                alert(validation.msg); // 검사 실패 메시지 출력
            }
        },
        reset() {
            this.sex = [];
            this.searchValidTypes = [];
            this.searchTeamIds = [];
            this.searchTicketTypes = [];
            this.searchTicketStatus = '';
            this.memberList = [];
            this.selected = [];
            this.deleteImage();
            this.fetchRemainInfo();
            this.smsReservePop = false;
            this.selectedMsgTemplate = '';
            // 모든 이미지 삭제
            while (this.images && this.images.length > 0) {
                this.deleteImage(0);
            }
            this.searchStr = '';
            this.resetSearchKeyword();
            Vue.nextTick(() => {
                console.log('123123123123123123213123213123', this.searchStr); // 이제 ''가 출력되어야 합니다.
            });
            this.searchValidTypes = [];
            this.searchKeyword = '';
        },
        removeAllStringFromArray(arr) {
            return arr.includes('all') ? arr.filter((a) => a !== 'all') : arr;
        },
        removeFromSelected(index) {
            console.log(index);
            if (index === 0) {
                this.selected.shift();
            } else {
                this.selected.splice(index, 1);
            }
            return false;
        },
        updateMember(field, value, index) {
            // memberList 배열의 특정 인덱스에 있는 항목을 업데이트합니다.
            this.memberList[index][field] = value;
        },
        // 전화번호 직접입력
        addDirectInputItem() {
            const lastItemId = this.memberList.length > 0 ? this.memberList[this.memberList.length - 1].id : 0;

            this.memberList.push({
                id: lastItemId + 1, // id는 현재 memberList의 길이에 1을 더한 값으로 설정
                centerCustomerId: null,
                name: '', // 초기 이름 값은 빈 문자열로 설정
                phone: '', // 초기 전화번호 값은 빈 문자열로 설정
                isEditable: true, // 이 항목이 직접 편집 가능함을 나타냄
                isDirectInput: true, // 직접 입력 항목임을 나타냄
            });
        },
        handleSelectedTextChange(selectedText) {
            // 선택된 텍스트 값을 처리하는 로직
            console.log('선택된 텍스트:', selectedText);
        },
        handleChargeAmountChange(selectedText) {
            this.selectedChargeAmount = selectedText;
            console.log('선택된 금액:', this.selectedChargeAmount);
        },
        handleSetCenter(selectedText) {
            this.selectedCenter = selectedText;
            console.log('선택된 센터:', this.selectedCenter);
            if (this.selectedCenter === '직접입력') {
                // '직접 입력' 관련 로직 처리
            }
        },
        handleSelectedCenter(selectedValue) {
            this.selectedCenter = selectedValue;
            console.log(`selectedCenter가 변경되었습니다: ${selectedValue}`);
        },
        handleChangeCenter(selectedText) {
            this.selectedCenter = selectedText;
            console.log('선택된 센터:', this.selectedCenter);
            if (this.selectedCenter === '직접입력') {
                // '직접 입력' 관련 로직 처리
            }
        },
        handleSelectChange(selectedValue) {
            this.selectedCenter = selectedValue;
            console.log(`selectedCenter가 변경되었습니다: ${selectedValue}`);
        },
        generateSignData() {
            const ediDate = moment().format('YYYYMMDDHHmmss');
            this.$refs.ediDateInput.value = ediDate;
            this.ediDate = ediDate + 1;
            const dataString = ediDate + this.MID + this.finalChargeAmount + this.merchantKey;
            const hash = CryptoJS.SHA256(dataString);
            const hexHash = CryptoJS.enc.Hex.stringify(hash);

            // signData 값 업데이트
            this.signData = hexHash;

            // ref를 사용하여 SignData 입력 필드의 value를 직접 업데이트
            if (this.$refs.signDataInput) {
                this.$refs.signDataInput.value = hexHash;
            }
        },
        async payBtn() {
            this.smsChargePop = true;

            const centerIdAsNumber = Number(this.cId);
            let responseData = null;
            try {
                const response = await paymentApi.post('/admin/api/payment/createOrder', {
                    centerId: centerIdAsNumber,
                });
                console.log('결제 준비 응답:', response.data);
                responseData = response.data;
            } catch (error) {
                console.error('결제 준비 요청 실패:', error);
            }
            this.Moid = responseData;
        },
        async nicepayStart() {
            if (!this.isAgreed) {
                alert('약관에 동의해주세요.');
                return;
            }
            if (this.finalChargeAmount <= 10000) {
                alert('1만원 이상부터 결제 가능합니다');
                return;
            }
            this.generateSignData();
            document.payForm.target = 'payForm';
            // goPay(document.payForm);
            goPay(document.payForm);
        },
        getMoid() {
            console.log('getMoid:', this.Moid);
            return this.Moid;
        },
        // 쉼표 찍기
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        updateAdvertPrefix() {
            this.advertText.prefix = `(광고) ${this.userInput}\n`;
            console.log('Updated advertText.prefix:', this.advertText.prefix);
        },
        async fetchRoleData() {
            try {
                const myInfo = await this.getMyInfo();
                this.roleId = myInfo.data.roleId;
                const params = {
                    centerId: this.centerId,
                    roleId: this.roleId,
                };
                const rolePermissions = await api.get(`/admin/api/centerStaffRole/staffMenu/event/all`, { params });

                rolePermissions.data.forEach((item) => {
                    if (item.centerMenuEventCustoms) {
                        item.centerMenuEventCustoms.forEach((custom) => {
                            let description = '';
                            switch (custom.menuEventCd) {
                                case 'ME_EVENT_001':
                                    description = '메세지 발송권한';
                                    break;
                                case 'ME_EVENT_002':
                                    description = '메세지 발송내역 조회권한';
                                    break;
                                case 'ME_EVENT_003':
                                    description = '메세지 내용설정 수정권한';
                                    break;
                                case 'ME_EVENT_004':
                                    description = '엑셀 일괄업로드 권한';
                                    break;
                            }
                            if (description) {
                                console.log('menuEventCd:', custom.menuEventCd, description, 'useYn:', custom.useYn);
                            }
                        });
                    }
                });
                rolePermissions.data.forEach((item) => {
                    if (item.centerMenuEventCustoms) {
                        item.centerMenuEventCustoms.forEach((custom) => {
                            this.$set(this.permissions, custom.menuEventCd, custom.useYn);
                        });
                    }
                });
            } catch (error) {
                console.error('Error fetching role data:', error);
            }
        },
        getMyInfo() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.staffId}`);
        },
        copy(event) {
            navigator.clipboard.writeText(event.target.innerText);
            return false;
        },
        dateInfoFn(date) {
            if (date === this.selectedDate) {
                return {
                    content: '선택된 날짜',
                };
            }
        },
        formatPhone(value) {
            let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
            phone = phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
            return phone;
        },
        updatePhone(member, value) {
            member.phone = this.formatPhone(value); // 전화번호 형식에 맞게 변환 후 저장
        },
        handleSelectedDate(newValue) {
            // newValue는 새로 선택된 날짜 값입니다.
            // this.selectedDate = newValue.activeYMD;
            this.selectedDate = newValue;
            console.log('11111111111선택된 날짜:', newValue);
            console.log('selectedDate:', this.selectedDate);
        },
    },
};
</script>
<style>
/*
.loading-indicator {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 2em;
    z-index: 1000;
}
*/
</style>
